/** Numeric model-usage summary shared by CLI and web presentation.
 *  Importless; its body is mirrored byte-for-byte in web/lib/modelUsageSummary.ts.
 *  tests/contract/webMirrorContracts.test.ts pins both copies. */

/** Numeric projection of the model ledger. Presentation formats these facts, never re-reduces them.
 * Totals sum finite known costs, skipping unpriced rows. Input order is preserved; the sorted view is a copy. */
export function summarizeModelUsage<T extends { usage: {
  total: number; cacheRead: number; cacheWrite: number; costUsd: number | null;
} }>(items: readonly T[]) {
  const models = [...items].sort((a, b) => b.usage.total - a.usage.total);
  let totalTokens = 0;
  let totalCacheTokens = 0;
  let totalCost = 0;
  for (const { usage } of models) {
    totalTokens += usage.total;
    totalCacheTokens += usage.cacheRead + usage.cacheWrite;
    if (typeof usage.costUsd === 'number' && Number.isFinite(usage.costUsd)) totalCost += usage.costUsd;
  }
  return {
    models, maxTokens: Math.max(1, models[0]?.usage.total ?? 0),
    totalTokens, totalCacheTokens, totalCost,
    hasAnyUsage: models.length > 0,
  };
}
